module.exports = __webpack_public_path__ + "static/01-19f167ee675e2bd5ce2f9eda19702e9b.jpg";